import { Button, DatePicker, Space } from "antd";
import moment from "moment";
import React, { useState } from "react";

function DateRangeSelect({ selectedRange, onSelectedRangeChanged = () => {} }) {
  const [dataRange, setDateRange] = useState(selectedRange);
  const [open, setOpen] = useState(false);

  const handleRangeChange = async (dates) => {
    let dateFrom = dates[0].split(" ");
    dateFrom = dateFrom[0] + " 00:00:00";
    let dateTo = dates[1].split(" ");
    dateTo = dateTo[0] + " 23:59:59";
    setDateRange([dateFrom, dateTo]);
  };

  return (
    <DatePicker.RangePicker
      onChange={(e, dates) => {
        if (!e) {
          return;
        }
        handleRangeChange(dates);
      }}
      allowClear={false}
      open={open}
      onOpenChange={(open) => {
        if (open) {
          setOpen(open);
        }
      }}
      value={[moment(dataRange[0]), moment(dataRange[1])]}
      disabledDate={(current) => current.isAfter(moment().subtract(0, "day"))}
      format="YYYY-MM-DD"
      renderExtraFooter={() => (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Space>
            <Button
              onClick={() => {
                setOpen(false);
                setDateRange(selectedRange);
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={() => {
                setOpen(false);
                onSelectedRangeChanged(dataRange);
              }}
            >
              Filter
            </Button>
          </Space>
        </div>
      )}
    />
  );
}

export default DateRangeSelect;
